import React from "react";
import { OverlayTrigger, OverlayTriggerProps, Tooltip } from "react-bootstrap";
import { Placement } from "react-bootstrap/esm/types";

const InfoTooltip = ({
  tooltip,
  overlayPlacement = "auto",
  overlayProps,
  buttonProps,
}: {
  tooltip: React.ReactNode;
  overlayPlacement?: Placement;
  overlayProps?: OverlayTriggerProps;
  buttonProps?: React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >;
}) => (
  <OverlayTrigger
    placement={overlayPlacement}
    overlay={<Tooltip>{tooltip}</Tooltip>}
    {...overlayProps}
  >
    <img
      src="/icons/info.svg"
      alt="Info icon"
      width={24}
      {...buttonProps}
      className={`svg ${buttonProps?.className ?? ""}`}
    />
  </OverlayTrigger>
);

export default InfoTooltip;
